<template>
	<div>
		<a class="reset-tab" id="reset-tab" tabindex="-1"></a>
		<a class="skip-link"
			id="skip-link"
			href="#main-content"
			@click.prevent="scrollToElement('#main-content')"
			@keyup.enter="scrollToElement('#main-content')"
			@keyup.space="scrollToElement('#main-content')"
			role="link"
			tabindex="0">
			{{$t('MAIN_CONTENT.Accessibility.skipToMainContent')}}
		</a>
		<div v-if="$store.getters.appIsReady">
			<header-bar
				v-if="!isTestBuilder"
				:suiteModule="suiteModule"
				:title="headerTitle"
				:key="`${role}_header`"
				@updateLocales="updateLocales"
			>
			</header-bar>
			<side-panel v-if="showSidePanel && screenLoaded" :key="`${role}_sidepanel`"></side-panel>
			<main id="main-content" :class="wrapperClass" tabindex="-1">
				 <webstores-modal v-if="this.studentIsSelected" :key="`${role}_webstores_modal`"></webstores-modal>
				<section :style="!isTestBuilder ? 'padding: 80px 15px 150px 15px;':''">
					<h1 v-if="$store.state.useHeader">
						<font-awesome-icon :icon="$store.state.titleIcon" v-if="!!$store.state.titleIcon">
						</font-awesome-icon> {{ $t($store.state.title) }}
					</h1>
					<section v-if="!isParentHome && !studentIsSelected && !isInSettings && students.length > 0">
						<div class="alert alert-danger">
							{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
						</div>
					</section>
					<div class="alert alert-danger" role="alert" v-if="$store.state.showError">
						<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
						{{ $t('MAIN_CONTENT.App.genericErrorMessage') }}
					</div>
					<div v-if="role === 'none'" class="alert alert-danger" role="alert">
						{{ $t('MAIN_CONTENT.App.permissionDeniedMessage') }}
					</div>
					<router-view :key="$route.fullPath + role" v-if="isParentHome || studentIsSelected || isInSettings"></router-view>
					<global></global>
				</section>
			</main>
		</div>
	</div>
</template>

<script>
	import Global from './components/Global.vue';
	import Header from './components/Common/Header.vue';
	import SidePanel from './components/Common/SidePanel.vue';
	import WebstoresModal from './components/Common/WebstoresModal.vue';

	import { mapGetters } from 'vuex';
	import moment from 'moment';

	export default {
		data() {
			return {
				suiteModule: 'comunity-web-portal',
				screenLoaded: false,
				headerTitle: 'Sapphire Community Portal'
			};
		},
		components: {
			Global,
			'header-bar': Header,
			SidePanel,
			WebstoresModal
		},
		computed: {
			...mapGetters(['getSidePanelKey', 'role', 'credType', 'students', 'getSelectedLocale']),
			isParentHome(){
				return this.$route.name === 'HomePage' || !this.$route.name;
			},
			isTestBuilder(){
				return this.routeIsDefined && (this.$route.name === 'testTaker' || this.$route.name === 'testReviewer');
			},
			isUserWizard(){
				return this.routeIsDefined && this.$route.name === 'UserConversionWizard' || this.$route.name === 'ForcePasswordChange';
			},
			routeIsDefined(){
				return !!this.$route.name;
			},
			studentIsSelected(){
				return !!this.$store.state.selectedStudentRID;
			},
			wrapperClass() {
				return !this.showSidePanel ? 'content-wrapper-full' : 'content-wrapper-aside-l';
			},
			isInSettings() {
				return this.$route.name === 'GeneralAccountSettings' ||
							 this.$route.name === 'StudentsSettings' ||
							 this.$route.name === 'NotificationSettings' ||
							 this.$route.name === 'DevicesAccountSettings';
			},
			showSidePanel(){
				return !this.isUserWizard && !this.isTestBuilder && (this.studentIsSelected || this.isInSettings);
			}
		},
		methods: {
			updateLocales( locale ) {
				moment.locale( locale );
				document.documentElement.setAttribute('lang', locale);
			},
			scrollToElement(id) {
				const element = $J(id);
				if (element) {
					element.offset().top
					element.focus()
				}
			},
		},
		mounted() {
			this.$nextTick(()=> {
				this.screenLoaded = true;
				this.$i18n.locale = this.getSelectedLocale.LOCALE_CODE;
				if( !!this.getSelectedLocale.LOCALE_CODE ){
					document.documentElement.setAttribute('lang', this.getSelectedLocale.LOCALE_CODE); 
				}
			});
		}
	}
</script>
